import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface Plan {
  id: string;
  name: string;
  display_name: string;
  description: string;
  price_monthly: number;
  price_yearly: number;
  currency: string;
  max_products: number | null;
  max_employees: number | null;
  max_warehouses: number | null;
  max_shops: number | null;
  max_desktop_devices: number | null;
  max_mobile_devices: number | null;
  sales_history_months: number | null;
  ai_credits_included: number;
  features: string[];
  is_active: boolean;
  is_free_promo_active: boolean;
  free_promo_end_date: string | null;
  is_currently_free_promo: boolean;
  sort_order: number;
  support_level?: 'community' | 'email_48h' | 'email_24h_chat' | 'priority_dedicated';
}

export function usePlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      const response = await api.get<Plan[]>('/plans');
      // API serializes decimal:2 columns as strings ("0.00"); coerce to numbers
      // so that comparisons like `price_monthly === 0` work as declared by the type.
      return response.data.map((plan) => ({
        ...plan,
        price_monthly: Number(plan.price_monthly),
        price_yearly: Number(plan.price_yearly),
        ai_credits_included: Number(plan.ai_credits_included ?? 0),
        support_level: plan.support_level,
      }));
    },
  });
}

export type { Plan };
